export default "__VITE_ASSET__807283c8__"